<template>
  <div class="date-box-wrap" >
    <div class="date-content-box" @click.stop="showDateList">
      <slot :date="chosenDate">
        <div class="date-input-wrap" :class="{ 'date-box-chosen':shouldDateListShow && !forShow, narrow: options && options.narrow, error: error, 'dark': forShow }">
          <div class="date-box-input" v-if="!forShow">
            <template v-if="!(selectedDisplayNone && chosenDate)">
              <div :class="['date-input-left']" v-if="!options || !options.narrow">选择日期</div>
            </template>
            <div :class="['date-input-right', {'date-input-right-10px': selectedDisplayNone}]" v-if="chosenDate">{{chosenDate | dateNamify}}</div>
            <div class="date-input-right" v-else style="color: #aaa;">请选择</div>
          </div>
        </div>
      </slot>
    </div>

    <div class="date-box-list"   v-show="shouldDateListShow" >
      <div class="date-list-title">
        <img class="arrow-left" @click.stop="toggleMonth(0)" src="https://o.666visa.cn/static/ssqpeer/order/icon-right-blue.png" alt="">
        <div class="title-value">
          <div class="month-box">{{nowMonth}}<span>月</span></div>
          <div class="year-box"><span>/</span>{{nowYear}}年</div>
        </div>
        <img class="arrow-right" @click.stop="toggleMonth(1)" src="https://o.666visa.cn/static/ssqpeer/order/icon-right-blue.png" alt="">
      </div>

      <div class="date-list-week">
        <span v-for="week in weekdayForShort" :key="week">{{week}}</span>
      </div>

      <div class="date-list-day">
        <div class="month-bg">{{nowMonth}}</div>
        <div class="date-day-item" v-for="(n,index) in nowMonthArr" :key="index"
          :style="{marginLeft: index === 0 ? beginDay*54+'px' : ''}"
          :class="{'chosenDay':nowYear === chosenYear&& nowMonth === chosenMonth&&(index+1)===chosenDay,
                      'disabled': isTodayDisabled(index), 'have-holiday': n.show && n.showText !== '最早',}"
          @click="choosedate(index+1, isTodayDisabled(index))">
          <div class="day-item-bg"></div>
          <div class="date-day-day">
            {{nowYear === todayYear&& nowMonth === todayMonth&&index + 1 === todayDate?'今天':index+1}}
          </div>

          <div class="date-day-icon" v-if="n.show" :class="{'is-weekend': n.showText === '休', 'is-holiday': n.showText === '假'}">
            <span v-if="n.showText === '休' && !hideWeek">{{n.showText}}</span>
            <span v-else-if="n.showText === '假' && !hideHoliday">{{n.showText}}</span>
          </div>
        </div>
      </div>

      <div class="date-list-subtitle">
        <div class="subtitle-box">
          <div class="subtitle-item weekend" v-if="!hideWeek">
            <img class="item-icon" src="https://o.666visa.cn/static/ssqpeer/order/calendar-weekend.png" alt="">
            <div class="item-value">周末休息</div>
          </div>
          <div class="subtitle-item holiday" v-if="!hideHoliday">
            <img class="item-icon" src="https://o.666visa.cn/static/ssqpeer/order/calendar-holiday.png" alt="">
            <div class="item-value">使馆放假</div>
          </div>
        </div>
      </div>
      <div class="date-tips-box" v-if="showTips || showEarly">
        <div class="date-tips-item" v-if="showTips">{{tips}}</div>
        <div class="date-tips-item" v-if="showEarly">建议按最长办理时间计划您的出行日期。由于近期领馆政策变动频繁，实际出签时间可能延迟，请以领事馆或签证中心结果为准。</div>
      </div>
    </div>
  </div>
</template>

<script>
import jia from '@/assets/imgs/products/jia.png';
import xiu from '@/assets/imgs/products/xiu.png';
import dateUtils from '../libs/date-util';

export default {
  props: ['departDate', 'minDisabledDate', 'holidayDateArr', 'options', 'maxDate', 'unselectable', 'error', 'forShow', 'showEarly', 'earlistDate', 'selectedDisplayNone', 'tips', 'showTips', 'hideWeek', 'hideHoliday'],
  data() {
    return {
      jia,
      xiu,

      shouldDateListShow: this.forShow || false,
      weekday: { 0: '星期日', 1: '星期一', 2: '星期二', 3: '星期三', 4: '星期四', 5: '星期五', 6: '星期六' },
      weekdayForShort: { 0: '日', 1: '一', 2: '二', 3: '三', 4: '四', 5: '五', 6: '六' },

      beginDay: 0, // 每个月开始第一天星期几
      nowYear: '', // 控件当前显示的日期
      nowMonth: '',
      nowDate: '',
      nowMonthArr: [], // 控件当前显示的月份数组

      todayYear: new Date().getFullYear(), // 今天的日期
      todayMonth: new Date().getMonth() + 1,
      todayDate: new Date().getDate(),

      holidayDate: [], // 放假数组

      chosenDate: '', // 选择的日期
      chosenYear: '',
      chosenMonth: '',
      chosenDay: '',

      disabledDate: new Date(), // 禁止选择的日期
      disabledYear: '',
      disabledMonth: '',
      disabledDay: '',
      fullHolidayStrArray: [],
    };
  },
  computed: {
    earliestDate() {
      if (this.disabledDate) {
        return new Date(new Date(this.disabledDate).getTime() + 86400000);
        // return new Date(new Date(this.disabledDate).getTime());
      }
      return this.disabledDate;
    },
  },
  created() {
    this.handleData();
  },
  mounted() {
    document.addEventListener('click', this.handleClick, true);
  },
  destroyed() {
    document.removeEventListener('click', this.handleClick, true);
  },

  watch: {
    departDate() {
      this.handleData();
    },
    minDisabledDate(val) {
      if (val) {
        this.handleData();
      }
    },
    holidayDateArr(val) {
      if (val) {
        this.handleData();
      }
    },
  },
  filters: {
    dateNamify(dateStr) {
      if (!dateStr) return '';
      return dateUtils.formatDateWithzeroWithWeek(dateStr);
    },
  },
  methods: {
    handleClick(e) {
      if (!this.$el.contains(e.target) && !this.forShow) {
        this.shouldDateListShow = false;
      }
    },
    // 初始化一些设置
    handleData() {
      // 设置传入的默认的选择日期
      if (this.departDate) {
        this.chosenYear = this.departDate.getFullYear();
        this.chosenMonth = this.departDate.getMonth() + 1;
        this.chosenDay = this.departDate.getDate();
        const newMonth = this.chosenMonth < 10 ? (`0${this.chosenMonth}`) : this.chosenMonth;
        const newDay = this.chosenDay < 10 ? (`0${this.chosenDay}`) : this.chosenDay;
        this.chosenDate = `${this.chosenYear}-${newMonth}-${newDay}`;
      } else {
        this.chosenDate = '';
        this.chosenYear = '';
        this.chosenMonth = '';
        this.chosenDay = '';
      }

      // 设置禁止选择的日期
      if (this.minDisabledDate) {
        this.disabledDate = new Date(this.minDisabledDate);
      }
      this.disabledYear = new Date(this.disabledDate).getFullYear();
      this.disabledMonth = new Date(this.disabledDate).getMonth() + 1;
      this.disabledDay = new Date(this.disabledDate).getDate();

      // 设置放假的数组
      if (this.holidayDateArr) {
        this.holidayDate = this.holidayDateArr;
        this.fullHolidayStrArray = this.holidayDateArr.map(({ date }) => date);
      }

      this.setMonthAndYear(this.chosenDate || this.disabledDate);
    },

    // 设置当前月份，年份，天数
    setMonthAndYear(defaultDate) {
      let date = '';
      if (!defaultDate) {
        date = new Date();
      } else {
        date = new Date(defaultDate);
      }
      date.setDate(1);
      this.beginDay = date.getDay();
      this.nowYear = date.getFullYear();
      this.nowMonth = date.getMonth() + 1;
      this.nowDate = date.getDate();

      const newArrLength = new Date(this.nowYear, this.nowMonth, 0).getDate();
      const newArr = [];
      let i = 0;
      while (i < newArrLength) {
        newArr.push({ show: false, showText: '' });
        i++;
      }
      // 加入休和假的显示数组
      newArr.forEach((day, ind) => {
        // 为了避免和最早和假在同一天 引起冲突
        if (!this.showEarly) {
          if (ind + 1 === this.earliestDate.getDate()
          && this.nowMonth === (this.earliestDate.getMonth() + 1)
          && this.nowYear === this.earliestDate.getFullYear()) {
            day.show = true;
            day.showText = '最早';
          }
        }
        this.holidayDate.forEach((element) => {
          if (ind + 1 === new Date(element.date).getDate()
              && this.nowMonth === (new Date(element.date).getMonth() + 1)
              && this.nowYear === new Date(element.date).getFullYear()
          ) {
            day.show = true;
            day.showText = element.dayText;
          }
        });
        // 为了避免和最早和假在同一天 引起冲突
        if (this.showEarly) {
          if (ind + 1 === this.earliestDate.getDate()
          && this.nowMonth === (this.earliestDate.getMonth() + 1)
          && this.nowYear === this.earliestDate.getFullYear()) {
            day.show = true;
            day.showText = '最早';
          }
        }
      });

      this.nowMonthArr = newArr;
    },
    // 切换月份，0减少月份，1增加月份
    toggleMonth(direction) {
      if (this.nowYear > this.todayYear + 30 || this.nowYear < this.todayYear - 30) {
        return;
      }

      if (this.nowMonth === 12 && direction === 1) {
        this.nowYear = this.nowYear + 1;
        this.nowMonth = 1;
      } else if (this.nowMonth === 1 && direction === 0) {
        this.nowYear = this.nowYear - 1;
        this.nowMonth = 12;
      } else if (direction === 1) {
        this.nowMonth = this.nowMonth + 1;
      } else if (direction === 0) {
        this.nowMonth = this.nowMonth - 1;
      }
      this.nowMonth = this.nowMonth < 10 ? `0${this.nowMonth}` : this.nowMonth;

      this.setMonthAndYear(`${this.nowYear}-${this.nowMonth}`);
      this.shouldDateListShow = true;
    },
    // 选择日期
    choosedate(day, disabled) {
      if (this.forShow) return;
      let chosenDateString = '';

      const newMonth = this.nowMonth < 10 ? (`0${this.nowMonth}`) : this.nowMonth;
      const newDay = day < 10 ? (`0${day}`) : day;

      chosenDateString = `${this.nowYear}-${newMonth}-${newDay}`;
      // const currentTime = new Date(chosenDateString).getTime();

      if (disabled) return;

      this.chosenYear = this.nowYear;
      this.chosenMonth = this.nowMonth;
      this.chosenDay = day;

      this.chosenDate = chosenDateString;

      this.shouldDateListShow = false;

      this.$emit('input', new Date(this.chosenDate));
    },
    isTodayDisabled(day) {
      day = day + 1 < 10 ? `0${day + 1}` : day + 1;
      const month = this.nowMonth < 10 ? `0${this.nowMonth}` : this.nowMonth;
      const currentDateStr = `${this.nowYear}-${month}-${day}`;
      const currentTime = new Date(currentDateStr).getTime();
      if (this.departDate && this.departDate.format('yyyy-MM-dd') === currentDateStr) return false;
      if (this.fullHolidayStrArray && this.fullHolidayStrArray.indexOf(currentDateStr) > -1) {
        return true;
      }
      if (this.unselectable && this.unselectable.map(({ date }) => date).indexOf(currentDateStr) > -1) {
        return true;
      }
      if (this.disabledDate.getTime() >= currentTime) {
        return true;
      } else if (this.maxDate) {
        return this.maxDate.getTime() <= currentTime;
      }
    },
    showDateList() {
      this.shouldDateListShow = !this.shouldDateListShow;
      if (this.$route.name === 'orderComfirm') {
        MtaH5.clickStat('payvisaorder0date');
      }
    },
    // 国家页时 放假和休息的图标已经背景图片显示
    iconBackground(n) {
      if (n.showText === '休') {
        return {
          backgroundImage: `url(${this.xiu})`,
        };
      }
      if (n.showText === '假') {
        return {
          backgroundImage: `url(${this.jia})`,
        };
      }
    },
  },

};
</script>

<style lang="less" scoped>
@import '../assets/less/variable';
.date-box-wrap{
  position: relative;
  display: inline-flex;
  width: 100%;
  .date-content-box{
    width: 100%;
    display: inline-flex;
  }
}
  .date-input-wrap {
    width: 100%;
    height: 40px;
    border: 1px solid #DEE2E6;
    line-height: 38px;
    font-size: 14px;
    border-radius: 4px;
    position: relative;
    transition: all 0.2s;
    background-color: #fff;
    cursor: pointer;
    &.narrow {
      height: 34px;
      line-height: 32px;
      .date-box-input {
        height: 32px;
        &:after {
          top: 13px;
        }
        .date-input-right {
          margin-left: 10px;
        }
      }
    }
    &.error {
      border-color: #f66878;
    }
    &.date-box-chosen {
      border: 1px solid #599FFF;
    }
    .date-box-input {
      display: flex;
      position: relative;
      align-items: center;
      &::after {
        content: '';
        position: absolute;
        top: 15px;
        right: 10px;
        border-top: 7px solid #97989d;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
      }
      .date-input-right-10px{
        margin-left: 10px !important;
      }
      .date-input-left {
        color: #5F666E;
        padding: 0 17px 0;
      }
      .date-input-right {
        color: #333333;
        margin-left: 40px;
      }
    }


  }
  .date-box-list {
    position: absolute;
    width: 414px;
    background-color: #ffffff;
    border-radius: 4px;
    z-index: 99;
    top: 100%;
    margin-top: 18px;
    left: 50%;
    transform: translateX(-50%);
    box-shadow:0px 10px 30px 0px rgba(131,146,167,0.2);
    border:1px solid rgba(233,238,242,1);
    line-height: 1;
    &::after{
      content: "";
      width: 15px;
      height: 15px;
      background: #E9EEF2;
      position: absolute;
      left: 50%;
      top: -9px;
      transform: rotate(45deg);
      z-index: 1;
    }
    &::before{
      content: "";
      width: 15px;
      height: 15px;
      background: #fff;
      position: absolute;
      left: 50%;
      top: -8px;
      transform: rotate(45deg);
      z-index: 2;
    }



    .date-list-title {
      position: relative;
      z-index: 3;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      .arrow-left{
        width: 12px;
        height: 12px;
        transform: rotate(180deg);
        cursor: pointer;
      }
      .title-value{
        margin: 0 12px;
        display: flex;
        align-items: center;
        .month-box{
          display: flex;
          align-items: center;
          color: #2F333D;
          font-size: 20px;
          font-weight: 600;
          span{
            margin-left: 2px;
            font-size: 12px;
            font-weight: 400;
            margin-top: 2px;
          }
        }
        .year-box{
          margin-left: 2px;
          color: #91999F;
          font-size: 14px;
          margin-top: 2px;
          span{
            margin-right: 2px;
          }
        }
      }

      .arrow-right{
        cursor: pointer;
        width: 12px;
        height: 12px;
      }
    }

    .date-list-week {
      background-color: #F5F7F9;
      height: 28px;
      font-size: 14px;
      color: #5F666E;
      display: flex;
      align-items: center;
      padding-left: 20px;
      span {
        width: 50px;
        margin-right: 4px;
        text-align: center;
        &:last-child{
          margin-right: 0;
          color: #FF5966;
        }
        &:first-child{
          color: #FF5966;
        }
      }
    }

    .date-list-day {
      padding-top: 16px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding-left: 20px;
      position: relative;
      z-index: 1;
      .month-bg{
        position: absolute;
        z-index: -1;
        font-size: 200px;
        color: #F3F6F9;
        top: 20px;
        left: 50%;
        transform: translateX(-50%);
        user-select: none;
      }
      .date-day-item {
        width: 50px;
        height: 40px;
        margin-bottom: 4px;
        margin-right: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 6px;
        color: #2F333D;
        cursor: pointer;
        border-radius:2px;
        position: relative;
        .day-item-bg{
          position: absolute;
          z-index: 1;
          left: 0;
          top: -6px;
          border-radius:2px;
          width: 100%;
          height: 100%;
        }
        .date-day-day {
          position: relative;
          z-index: 3;
          font-size: 16px;
          font-weight: 600;
        }
        .date-day-icon{
          position: relative;
          z-index: 3;
          margin-top: 3px;
          font-size: 12px;
          &.is-weekend {
            color: #599FFF;
          }
          &.is-holiday {
            color: #FF6464;
          }
        }
        &.disabled {
          cursor: not-allowed;
          color: #C9CDD1;
          .date-day-day{
            font-weight: 400;
          }
        }
        &.chosenDay{
          color: #fff;
          &.have-holiday .day-item-bg{
            top: 0;
          }
          .day-item-bg{
            background:linear-gradient(135deg,rgba(79,153,255,1) 0%,rgba(31,124,255,1) 100%);
            &::after{
              content: "";
              position: absolute;
              bottom: -1px;
              left: 50%;
              transform: translateX(-50%);
              z-index: 1;
              background: #599FFF;
              filter:blur(4px);
              width:39px;
              height:4px;
            }
          }
        }
      }
    }

    .date-list-subtitle {
      padding: 10px 20px;
      background: #F5F7F9;
      .subtitle-box{
        display: flex;
        align-items: center;
        .subtitle-item{
          display: flex;
          align-items: center;
          margin-right: 20px;
          .item-icon{
            height: 16px;
            margin-right: 4px;
          }
          .item-value{
            color: #5F666E;
            font-size: 12px;
          }
        }
      }
    }

    .date-tips-box{
      width: 100%;
      background: #FFF6DD;
      font-size: 12px;
      line-height: 17px;
      color: #FF8033;
      padding: 4px 20px;
      .date-tips-item{
        padding: 4px 0;
      }
    }
  }
</style>

<style lang="less">
  .date-box {
    &.dark {
      border: none;
      color: #fff;
      .date-box-list{
        width: 330px;
        height: 225px;
        top: 0px;
        right: 20px;
        background-color:rgba(2,2,2,0.45);
        box-shadow: 0px 0px 20px 0px rgba(255, 255, 255, 0.2);
        user-select:none;
        .date-list-title{
          height: 30px;
          line-height: 30px;
          color: #fff;
          font-size: 14px;
        }
        .date-list-week{
          height: 20px;
          line-height: 20px;
          padding: 0 15px 0 5px;
          background-color: rgba(234,243,255,0.2);
          color: #fff;
          font-size: 12px;
        }
        .date-list-day{
          height: 150px;
          padding: 0px 5px;
          .date-day-item{
            width: 34px;
            height: 15px;
            margin: 5px 5px;
            font-size: 0;
            cursor: default;
            position: relative;
            .date-day-day{
              width: 34px;
              height: 15px;
              line-height: 15px;
              font-size: 12px;
              &:hover{
                background-color: transparent !important;
              }
            }
            .disabled{
              cursor: default !important;
              &:hover{
                background-color: transparent !important;
              }
            }
            .date-day-icon-embassy{
              background-repeat: no-repeat;
              background-size: cover;
              position: absolute;
              top: -1px;
              right: -9px;
              width: 36px;
              height: 18px;
              z-index: -1;
            }
          }
        }
        .date-list-subtitle{
          height: 25px;
          border-top: 1px solid rgba(240,240,240,0.2);
          color: #fff;
          padding: 0 17px;
          flex-wrap: nowrap;
          .date-subtitle-icon{
            background-color: #599FFF;
            transform: scale(0.8);
          }
          .date-subtitle-text{
            color: #fff;
            font-size: 12px;
          }
          .date-subtitle-icon-embassy{
            transform: scale(0.8);
            font-size: 12px;
            width: 16px;
            height: 16px;
            line-height: 16px;
            font-size: 12px;
            border-radius: 50%;
            text-align: center;
            color: #ffffff;
            margin-right: 5px;
            background-color: #ff5a60;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/holiday-date-picker.vue